import { render } from "./Learn.vue?vue&type=template&id=21d3202e&scoped=true"
import script from "./Learn.vue?vue&type=script&lang=js"
export * from "./Learn.vue?vue&type=script&lang=js"

import "./Learn.vue?vue&type=style&index=0&id=21d3202e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d3202e"]])

export default __exports__